// extracted by mini-css-extract-plugin
export var measureBox = "_co-0";